import React from 'react'
import { useHistory } from 'react-router-dom'
import { SvgIconComponent } from '@mui/icons-material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Typography, Box, Button, Tooltip } from '@mui/material'
import { useStyles } from './styles'

type Props = {
  icon?: SvgIconComponent,
  title: string,
  newRoute?: string,
  newButtonLabel?: string,
  backRoute?: string,
  backButtonLabel?: string,
  showSaveButton?: boolean,
  saveButtonLabel?: string,
  showUploadButton?: boolean,
  showNewButton?: boolean,
  uploadButtonLabel?: string,
  uploadButtonFileTypes?: string,
  helpText?: string
  isLoading?: boolean
}

const renderNewButton = (showButton?: boolean, history?: any, route?: string, newButtonLabel?: string, isLoading?: boolean) => {
  if (typeof route !== 'undefined') {
    if (!showButton) {
      return <Button variant="contained" color="primary" disabled={isLoading ?? false} onClick={() => history.push(route)}>{newButtonLabel ?? 'Novo'}</Button>
    }
  }
}

const renderBackButton = (history: any, route?: string, backButtonLabel?: string, isLoading?: boolean) => {
  if (typeof route !== 'undefined') {
    return <Button variant="contained" color="primary" disabled={isLoading ?? false} onClick={() => history.push(route)} style={{ marginLeft: 10 }} >{backButtonLabel ?? 'Retornar'}</Button>
  }
}

const renderSaveButton = (showButton?: boolean, saveButtonLabel?: string, isLoading?: boolean) => {
  if (typeof showButton !== 'undefined') {
    if (showButton) {
      return <Button type="submit" variant="contained" color="primary" disabled={isLoading ?? false}>{saveButtonLabel ?? 'Salvar'}</Button>
    }
  }
}

const renderUploadButton = (showButton?: boolean, uploadButtonLabel?: string, uploadButtonFileTypes?: string, isLoading?: boolean) => {
  if (typeof showButton !== 'undefined') {
    if (showButton) {
      return <Button component="label" variant="contained" color="primary" disabled={isLoading ?? false} style={{ marginRight: 10 }}>{uploadButtonLabel || 'Upload'}<input type="file" accept={uploadButtonFileTypes || '*.*'} hidden /></Button>
    }
  }
}

const renderHelpIcon = (classes: any, helpText?: string, isLoading?: boolean) => {
  if (typeof helpText !== 'undefined') {
    if (helpText) {
      return (
        <Tooltip title={helpText} placement="right-end" arrow={true} disableInteractive={isLoading ?? false}>
          <HelpOutlineIcon className={classes.formTitleHelpIcon} />
        </Tooltip>
      )
    }
  }
}


const FormHeader: React.FC<Props> = ({
  icon,
  title,
  newRoute,
  newButtonLabel,
  backRoute,
  backButtonLabel,
  showSaveButton,
  saveButtonLabel,
  showUploadButton,
  showNewButton = false,
  uploadButtonLabel,
  uploadButtonFileTypes,
  helpText,
  isLoading
}: Props) => {
  const FormIcon = icon

  const classes = useStyles()
  const history = useHistory()

  return (
    <Typography variant="h5" className={classes.formTitle}>
      <Box className={classes.formTitleLeft}>
        {title}
        {renderHelpIcon(classes, helpText)}
      </Box>
      <Box className={classes.formButtonsRight}>
        {renderUploadButton(showUploadButton, uploadButtonLabel, uploadButtonFileTypes, isLoading)}
        {renderNewButton(showNewButton, history, newRoute, newButtonLabel, isLoading)}
        {renderSaveButton(showSaveButton, saveButtonLabel, isLoading)}
        {renderBackButton(history, backRoute, backButtonLabel, isLoading)}
      </Box>
    </Typography>
  )
}

export { FormHeader }
